import React, { useState, useRef } from "react";
import ClientNavbar from "../layout/ClientNavbar";
import { NavLink } from "react-router-dom";
import { FiSearch, FiFolder, FiPlus, FiX, FiFileText, FiDownload, FiTrash2 } from "react-icons/fi";

const styles = {
  primary: "#0d9488",
  primaryGreen: "#10b981",
  text: "#1e293b",
  textMuted: "#64748b",
  border: "#e2e8f0",
  bgCard: "#ffffff",
  bgPage: "#f8fafc",
};

const DOC_CATEGORIES = [
  "PAN Card",
  "Aadhar Card",
  "Transaction Slip",
  "KYC",
  "Photo",
  "Driving License",
  "General",
];

function formatDate(d) {
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
}

export default function Documents() {
  const [searchQuery, setSearchQuery] = useState("");
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("PAN Card");
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);
  const [currentFolder, setCurrentFolder] = useState(null);
  const [documents, setDocuments] = useState([]);
  const nextIdRef = useRef(1);
  const [hoveredDocId, setHoveredDocId] = useState(null);

  const folders = [{ id: 1, name: "MANN" }];

  const currentDocuments = currentFolder
    ? documents.filter((d) => d.folderId === currentFolder.id)
    : [];

  const handleAddFolder = (folder) => {
    setCurrentFolder(folder);
    setShowUploadModal(true);
  };

  const handleOpenFolder = (folder) => {
    setCurrentFolder(folder);
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) setSelectedFile(file);
    e.target.value = "";
  };

  const handleCloseUpload = () => {
    setShowUploadModal(false);
    setSelectedFile(null);
  };

  const handleUploadSubmit = () => {
    if (!selectedFile || !currentFolder) return;
    const prefix = selectedCategory.replace(/\s+/g, "_").toLowerCase();
    const displayName = `${prefix}_gpsfinvest.investwell.app_${selectedFile.name}`;
    setDocuments((prev) => [
      ...prev,
      {
        id: nextIdRef.current++,
        name: displayName.length > 45 ? displayName.slice(0, 42) + "..." : displayName,
        fullName: displayName,
        uploadDate: formatDate(new Date()),
        category: selectedCategory,
        folderId: currentFolder.id,
      },
    ]);
    handleCloseUpload();
  };

  const handleAddDocumentClick = () => {
    if (currentFolder) setShowUploadModal(true);
  };

  const handleDownload = (e, doc) => {
    e.stopPropagation();
    alert(`Download: ${doc.fullName || doc.name}`);
  };

  const handleDelete = (e, doc) => {
    e.stopPropagation();
    if (window.confirm("Delete this document?")) {
      setDocuments((prev) => prev.filter((d) => d.id !== doc.id));
    }
  };

  return (
    <>
      <ClientNavbar />
      <div className="page-content" style={{ background: styles.bgPage, minHeight: "100vh" }}>
        {/* Header */}
        <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: "12px", overflow: "hidden" }}>
          <div
            className="card-body p-4"

          >
            <div className="d-flex justify-content-between align-items-center flex-wrap">
              <div>
                <h3 className="text-primary mb-2">Safe Document Vault</h3>
                <nav
                  aria-label="breadcrumb"
                  style={{ "--bs-breadcrumb-divider": "none" }}
                >
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <NavLink to="/overview">Dashboard</NavLink> /
                    </li>
                    <li className="breadcrumb-item active">Documents</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>

        <div
          style={{
            background: styles.bgCard,
            borderRadius: "12px",
            border: `1px solid ${styles.border}`,
            boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
            padding: "24px",
          }}
        >
          <h2 style={{ fontSize: "16px", fontWeight: 600, color: styles.text, marginBottom: 12 }}>
            Search Documents
          </h2>
          <div style={{ marginBottom: 16 }}>
            <div style={{ position: "relative", maxWidth: 400 }}>
              <FiSearch
                size={18}
                style={{
                  position: "absolute",
                  left: 14,
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: styles.textMuted,
                }}
              />
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Search Documents..."
                style={{
                  width: "100%",
                  padding: "12px 14px 12px 44px",
                  fontSize: "14px",
                  border: `1px solid ${styles.border}`,
                  borderRadius: "8px",
                  outline: "none",
                }}
              />
            </div>
          </div>

          {currentFolder && (
            <nav style={{ marginBottom: 20, fontSize: "14px", color: styles.textMuted }}>
              <span
                style={{ color: styles.primary, cursor: "pointer", textDecoration: "none" }}
                onClick={() => setCurrentFolder(null)}
              >
                My Documents
              </span>
              <span style={{ margin: "0 6px" }}>&gt;</span>
              <span style={{ color: styles.text, fontWeight: 500 }}>{currentFolder.name}</span>
            </nav>
          )}

          {!currentFolder ? (
            <div
              style={{
                minHeight: 280,
                padding: "32px 24px",
                background: "#fafafa",
                borderRadius: "12px",
                border: `1px solid ${styles.border}`,
                display: "flex",
                flexWrap: "wrap",
                gap: 24,
                alignItems: "flex-start",
                alignContent: "flex-start",
              }}
            >
              {folders.map((folder) => (
                <div
                  key={folder.id}
                  style={{
                    position: "relative",
                    width: 120,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  onClick={() => handleOpenFolder(folder)}
                >
                  <div
                    style={{
                      position: "relative",
                      width: 80,
                      height: 64,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <FiFolder size={64} style={{ color: "#93c5fd" }} />
                    <button
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleAddFolder(folder);
                      }}
                      style={{
                        position: "absolute",
                        top: -4,
                        right: -4,
                        width: 28,
                        height: 28,
                        borderRadius: "50%",
                        background: styles.primary,
                        color: "#fff",
                        border: "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        boxShadow: "0 2px 8px rgba(13,148,136,0.4)",
                      }}
                    >
                      <FiPlus size={16} />
                    </button>
                  </div>
                  <span style={{ marginTop: 10, fontSize: "14px", fontWeight: 600, color: styles.text, textAlign: "center" }}>
                    {folder.name}
                  </span>
                </div>
              ))}
            </div>
          ) : (
            <div
              style={{
                padding: "24px",
                background: "#fff",
                borderRadius: "12px",
                border: `1px solid ${styles.border}`,
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))",
                gap: 20,
              }}
            >
              <div
                role="button"
                tabIndex={0}
                onClick={handleAddDocumentClick}
                onKeyDown={(e) => e.key === "Enter" && handleAddDocumentClick()}
                style={{
                  minHeight: 200,
                  border: `1px solid ${styles.border}`,
                  borderRadius: "12px",
                  background: "#fff",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  transition: "border-color 0.2s, box-shadow 0.2s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = styles.primary;
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.06)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = styles.border;
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <div
                  style={{
                    width: 56,
                    height: 56,
                    borderRadius: "50%",
                    background: "#f1f5f9",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: 12,
                  }}
                >
                  <FiPlus size={28} style={{ color: styles.textMuted }} />
                </div>
                <span style={{ fontSize: "14px", fontWeight: 500, color: styles.textMuted }}>Add Document</span>
              </div>

              {currentDocuments.map((doc) => (
                <div
                  key={doc.id}
                  style={{
                    minHeight: 200,
                    border: `1px solid ${styles.border}`,
                    borderRadius: "12px",
                    background: "#fff",
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column",
                    transition: "border-color 0.2s, box-shadow 0.2s",
                    position: "relative",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = styles.primary;
                    e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.06)";
                    setHoveredDocId(doc.id);
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = styles.border;
                    e.currentTarget.style.boxShadow = "none";
                    setHoveredDocId(null);
                  }}
                >
                  <div
                    style={{
                      height: 120,
                      background: "linear-gradient(135deg, #f0fdfa 0%, #e0f2fe 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "relative",
                    }}
                  >
                    <FiFileText size={48} style={{ color: styles.primary }} />
                    {hoveredDocId === doc.id && (
                      <div
                        style={{
                          position: "absolute",
                          top: 8,
                          right: 8,
                          display: "flex",
                          gap: 8,
                        }}
                      >
                        <button
                          type="button"
                          onClick={(e) => handleDownload(e, doc)}
                          title="Download"
                          style={{
                            width: 36,
                            height: 36,
                            borderRadius: "8px",
                            border: "none",
                            background: "#fff",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            color: styles.primary,
                          }}
                        >
                          <FiDownload size={18} />
                        </button>
                        <button
                          type="button"
                          onClick={(e) => handleDelete(e, doc)}
                          title="Delete"
                          style={{
                            width: 36,
                            height: 36,
                            borderRadius: "8px",
                            border: "none",
                            background: "#fff",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            color: "#ef4444",
                          }}
                        >
                          <FiTrash2 size={18} />
                        </button>
                      </div>
                    )}
                  </div>
                  <div style={{ padding: "12px 14px", flex: 1 }}>
                    <div
                      style={{
                        fontSize: "13px",
                        fontWeight: 600,
                        color: styles.text,
                        marginBottom: 6,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                      title={doc.fullName || doc.name}
                    >
                      {doc.name}
                    </div>
                    <div style={{ fontSize: "12px", color: styles.textMuted }}>Upload date: {doc.uploadDate}</div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Upload Documents Popup */}
      {showUploadModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.45)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1050,
            padding: 24,
          }}
          onClick={handleCloseUpload}
        >
          <div
            style={{
              width: "100%",
              maxWidth: 480,
              background: "#fff",
              borderRadius: "12px",
              boxShadow: "0 20px 60px rgba(0,0,0,0.2)",
              overflow: "hidden",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                padding: "16px 20px",
                backgroundColor: styles.primaryGreen,
                color: "#fff",
                fontSize: "18px",
                fontWeight: 700,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <span>Upload Documents</span>
              <button
                type="button"
                onClick={handleCloseUpload}
                style={{
                  background: "rgba(255,255,255,0.2)",
                  border: "none",
                  width: 36,
                  height: 36,
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  color: "#fff",
                }}
              >
                <FiX size={20} />
              </button>
            </div>
            <div style={{ padding: "24px" }}>
              <label style={{ display: "block", marginBottom: 10, fontSize: "14px", fontWeight: 600, color: styles.text }}>
                Please select category of file:
              </label>
              <select
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
                style={{
                  width: "100%",
                  padding: "12px 16px",
                  fontSize: "14px",
                  border: `1px solid ${styles.border}`,
                  borderRadius: "8px",
                  outline: "none",
                  marginBottom: 20,
                  color: styles.text,
                  backgroundColor: "#fff",
                  cursor: "pointer",
                }}
              >
                {DOC_CATEGORIES.map((cat) => (
                  <option key={cat} value={cat}>
                    {cat}
                  </option>
                ))}
              </select>

              <div
                style={{
                  border: `2px dashed ${styles.primaryGreen}`,
                  borderRadius: "8px",
                  padding: "32px 24px",
                  textAlign: "center",
                  marginBottom: 12,
                  background: "#f0fdfa",
                }}
              >
                <input
                  ref={fileInputRef}
                  type="file"
                  accept=".txt,.jpg,.jpeg,.png,.pdf,.csv,.doc,.docx"
                  onChange={handleFileChange}
                  style={{ display: "none" }}
                />
                <button
                  type="button"
                  onClick={() => fileInputRef.current?.click()}
                  style={{
                    padding: "10px 24px",
                    border: `2px solid ${styles.primaryGreen}`,
                    borderRadius: "8px",
                    background: "#fff",
                    color: styles.text,
                    fontSize: "14px",
                    fontWeight: 600,
                    cursor: "pointer",
                  }}
                >
                  Choose File
                </button>
                {selectedFile && (
                  <p style={{ marginTop: 12, fontSize: "13px", color: styles.textMuted }}>
                    {selectedFile.name}
                  </p>
                )}
              </div>
              <p style={{ fontSize: "12px", color: styles.textMuted, marginBottom: 4 }}>
                One file at a time. Supported file formats are text/jpg/jpeg/png/pdf/csv/doc/docx.
              </p>
              <p style={{ fontSize: "12px", color: styles.textMuted, marginBottom: 20 }}>
                File size should be less than 2 MB.
              </p>
              <div style={{ display: "flex", gap: 12, justifyContent: "flex-end" }}>
                <button
                  type="button"
                  onClick={handleCloseUpload}
                  style={{
                    padding: "10px 20px",
                    border: `1px solid ${styles.border}`,
                    borderRadius: "8px",
                    background: "#fff",
                    color: styles.textMuted,
                    fontSize: "14px",
                    fontWeight: 600,
                    cursor: "pointer",
                  }}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={handleUploadSubmit}
                  disabled={!selectedFile}
                  style={{
                    padding: "10px 20px",
                    border: "none",
                    borderRadius: "8px",
                    background: selectedFile ? styles.primaryGreen : "#cbd5e1",
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: 600,
                    cursor: selectedFile ? "pointer" : "not-allowed",
                  }}
                >
                  Upload
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
